import { getLocal, setLocal, getUrlParam } from '@/utils/utils'
import ConfigModel from '../../models/config/config.model'
import StoreCustomerManagementController from './storeCustomerManagement.controller'
import StoreThemeController from './storeTheme.controller.js'
import { FRONT_URL } from '@/utils/http/baseUrl'
// * 大健康门店系统 - api控制器
import StoreApiController from '@/controllers/storeController/view/store/storeApi.controller.js'
// * MODEL
import storeConfigModel from '@/controllers/storeController/models/config/config.model'
// 门店 - 相关接口
import { getUserAccInfo } from '@/controllers/storeController/api/storeManager.api'

import store from '@/store'
import { Notify } from 'vant'

/**
 * * 大健康门店系统 - 业务层控制器
 * */
class StoreController {
  // * 店铺客户模块 - 初始化
  static init(that) {
    // * 门店代理模块
    if (StoreController.isStoreCustomer(that)) {
      StoreCustomerManagementController.init()
    }
  }

  // * 直播间id
  static zbId() {
    return getLocal(ConfigModel['ZBID_KEY']) || 0
  }

  // * 门店id
  static storeId() {
    const storeInfo = StoreController.storeInfo()
    return storeInfo ? parseInt(storeInfo.id) : 0
  }

  // * 获取门店信息
  static storeInfo() {
    return getLocal(ConfigModel['STORE_INFO_KEY']) || {}
  }

  // * 负责人信息
  static storeUserInfo() {
    return getLocal(ConfigModel['USER_INFO_KEY']) || {}
  }

  // * 返回当前负责人类型
  // * 0：门店，1：区域。2：分公司
  static storeUserType() {
    let isStore = StoreController.isStore(false)
    if (!isStore) {
      return 0
    } else {
      return getLocal(ConfigModel['USER_INFO_KEY'])?.type || 0
    }
  }

  /** accountType变更判断 */
  static checkAccountType() {
    let urlType = getUrlParam('accountType')
    let localType = getLocal(ConfigModel['USER_INFO_KEY'])?.type || 0
    return urlType && urlType != localType
  }

  // * 当前是否门店系统下的模块
  static isStore(status = true) {
    const STORE_META_KEY =
      window.vzanLiveApp?.$route?.meta[ConfigModel['ROUTE_META_KEY']]
    if (status && STORE_META_KEY) {
      StoreController.throttle(StoreController.storeNotifyInit(), 1500)
    }
    return STORE_META_KEY
  }

  // * 当前是否门店系统下的模块
  static async lianUserId() {
    const userType = StoreController.storeUserType()
    let lianUserId =
      getUrlParam('lianUserId') || getLocal(ConfigModel['LIAN_USER_KEY'])
    if (!lianUserId || lianUserId === 'undefined') {
      console.log('发起请求', lianUserId)
      const storeId = StoreController.storeId()
      const zbId = StoreController.zbId()
      const res = await getUserAccInfo({
        // busType: 6,
        busType: storeConfigModel.STORE_BUS_TYPE[userType],
        relationId: storeId.toString(),
        tenantId: zbId,
      })
      if (res && res.code === 0 && res.data) {
        lianUserId = res.data.lianUserId
        setLocal(ConfigModel['LIAN_USER_KEY'], lianUserId)
      }
    }
    return lianUserId
  }

  // * 当前是否门店客户模块
  static isStoreCustomer() {
    return ['storeCustomerManagement'].includes(window.vzanLiveApp.$route.name)
  }

  // * 请求头配置初始化
  static apiHeaderConfig() {
    const userType = StoreController.storeUserType()
    return {
      customHeaders: {
        Authorization: getLocal(ConfigModel.TOKEN_KEY),
        zbid: getLocal(ConfigModel['ZBID_KEY']),
        StoreType: userType,
      },
    }
  }

  // * BILL_API服务 - 门店系统相关接口公共入参
  static billApiStoreParams(style = 1) {
    const isStore = StoreController.isStore()
    switch (style) {
      case 1:
        // * from // 来源 - 0：代理，4：门店负责人
        return isStore
          ? {
              storeId: StoreController.storeId(),
              from: 4,
            }
          : {
              from: 0,
            }
      case 2:
        return isStore
          ? {
              from: 4,
              selfTakeStoreId: StoreController.storeId(),
              storeId: 0,
            }
          : {}
      default:
        return {}
    }
  }

  // * 判断门店系统登录状态
  static storeLoginStatus() {
    return (
      getLocal(ConfigModel['TOKEN_KEY']) &&
      getLocal(ConfigModel['USER_INFO_KEY'])
    )
  }

  // * 门店系统打烊提示
  static storeNotifyInit() {
    let placeholderDom = document.getElementById('storeNotifyPlaceholder')
    if (placeholderDom) placeholderDom.parentNode.removeChild(placeholderDom)
    if (StoreController.StoreBusinessStatus()) {
      Notify.clear()
    } else {
      const userType = StoreController.storeUserType()
      const msgList = {
        0: '门店已打烊',
        1: '区域已被停用',
        2: '分公司已被停用',
      }
      Notify({
        type: 'warning',
        message: `${msgList[userType]}，如需恢复经营，请联系总部`,
        duration: 0,
        background: 'var(--primary-plain-color)',
      })
      let placeholder = document.createElement('div')
      placeholder.style.minHeight = '0.36rem'
      placeholder.id = 'storeNotifyPlaceholder'
      document.body.insertBefore(placeholder, document.body.firstChild)
    }
  }

  static storeAgentCenterName() {
    const userType = StoreController.storeUserType()
    const names = {
      0: '门店中心',
      1: '区域中心',
      2: '公司管理',
    }
    return names[userType]
  }

  static storeTypeName() {
    const userType = StoreController.storeUserType()
    const names = {
      0: '门店',
      1: '区域',
      2: '分公司',
    }
    return names[userType]
  }

  static storeTypeChildName() {
    const userType = StoreController.storeUserType()
    const names = {
      0: '员工',
      1: '门店',
      2: '区域',
    }
    return names[userType]
  }

  static storeNotifyClose() {
    let placeholderDom = document.getElementById('storeNotifyPlaceholder')
    if (placeholderDom) placeholderDom.parentNode.removeChild(placeholderDom)
  }

  // * 跳转大健康 - 门店系统工作台首页
  static goStoreIndex() {
    let zbId = StoreController.zbId() || getUrlParam('zbid')
    let userType = StoreController.storeUserType()
    if (!userType) {
      userType = getUrlParam('accountType') || 0
    }
    const url = `https://${window.location.host}/m/store/#/index?zbid=${zbId}&accountType=${userType}`
    location.href = url
  }

  // * 跳转大健康 - 门店系统登录页
  static goStoreLogin() {
    let zbId = StoreController.zbId() || getUrlParam('zbid')
    let userType = getUrlParam('accountType') || 0
    if (!userType) {
      userType = getLocal(ConfigModel['USER_INFO_KEY'])?.type || 0
    }
    const url = `https://${window.location.host}/m/store/#/login?zbid=${zbId}&accountType=${userType}`
    location.href = url
  }

  // * 获取门店状态
  static async getCurrentStoreInfoData() {
    try {
      const res = await StoreApiController.getCurrentBaseInfo()
      if (res && res.dataObj) {
        store.commit('SET_STORE_BUSINESS_STATUS', res.dataObj.businessStatus)
        store.commit('SET_STORE_STATUS', res.dataObj.status)
      }
    } catch (e) {
      console.log('getCurrentStoreInfoData => ', e)
    }
  }

  /**
   * * 门店系统是否可操作
   * * true && false
   */
  static StoreBusinessStatus() {
    const isStore = StoreController.isStore(false)
    const businessStatus = store.getters.storeBusinessStatus
    const status = store.getters.storeStatus
    const userType = StoreController.storeUserType()
    if (userType === 0) {
      return !isStore || businessStatus !== 2
    } else {
      return !isStore || status
    }
  }

  static throttle(func, delay = 300) {
    let timeoutId
    return function (...args) {
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          timeoutId = null
          func.apply(this, args)
        }, delay)
      }
    }
  }

  /**
   * * 样式控制
   */
  // * 门店系统通用头部样式
  static headerStyle() {
    const isStore = StoreController.isStore()
    return isStore
      ? {
          background: 'var(--primary-background-linear-gradient)',
          backgroundSize: '100%',
          backgroundRepeat: 'no-repeat',
        }
      : {}
  }

  // * 通用主题渐变样式
  static bgStyle() {
    const isStore = StoreController.isStore()
    return isStore
      ? {
          background: 'var(--primary-background-linear-gradient)',
          color: '#fff',
        }
      : {}
  }

  // * 通用按钮渐变样式
  static btnBgStyle() {
    const isStore = StoreController.isStore()
    return isStore
      ? {
          background: 'var(--primary-background-btn-linear-gradient)',
          color: '#fff',
        }
      : {}
  }

  static plainBgStyle() {
    const isStore = StoreController.isStore()
    return isStore
      ? {
          background: '#f9efe6',
          color: 'var(--primary-color)',
        }
      : {}
  }

  static activeBgStyle() {
    const isStore = StoreController.isStore()
    return isStore
      ? {
          background: '#f9efe6',
          color: 'var(--primary-color)',
          border: '1px solid var(--primary-color)',
        }
      : {}
  }

  static borderStyle() {
    const isStore = StoreController.isStore()
    return isStore
      ? {
          border: '1px solid var(--primary-color)',
          color: 'var(--primary-color)',
        }
      : {}
  }

  // * 通用字体样式
  static fontColorStyle() {
    const isStore = StoreController.isStore()
    return isStore
      ? {
          color: '#552700',
        }
      : {}
  }

  // * 主题色样式
  static primaryColorStyle() {
    const isStore = StoreController.isStore()
    const userType = StoreController.storeUserType()
    console.log(
      "ConfigModel['PRIMARY_COLORS'][userType] ==> ",
      ConfigModel['PRIMARY_COLORS']
    )
    return isStore
      ? {
          color: ConfigModel['PRIMARY_COLORS'][userType],
        }
      : {}
  }

  // * 根据账号类型初始化主题样式变量
  static setTheme() {
    StoreThemeController.setTheme() // 更新主题
  }
}

export default StoreController
